// HomePage — редирект на роле-домашнюю страницу.
// Создатель  → /tenants    (главное действие — управление Клиентами)
// Куратор    → /tenants    (помощник Создателя — заводит клиентов, ставит тариф)
// Админ/РОП  → /users      (главное действие — работа со своей командой)
// МОП        → /trainer    (главное действие — тренироваться)

import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.jsx';

const HOME_BY_ROLE = {
    creator: '/tenants',
    curator: '/tenants',
    admin: '/users',
    rop: '/users',
    mop: '/trainer',
};

export default function HomePage() {
    const { user } = useAuth();
    const target = HOME_BY_ROLE[user?.role] || '/trainer';
    return <Navigate to={target} replace />;
}
